import React from 'react';
import { CustomDivider } from './SectionDivider.styles';

const SectionDivider = ({ className }) => {
  return <CustomDivider className={className} />;
};

export default SectionDivider;
